export const stripe_connect_options = {
  stripe_connect_activated: {
    fieldPath: 'stripe_connect_activated',
    fieldReadPath: 'stripe_connect_activated',
    name: 'stripe_connect_activated',
    label: 'core.stripe.stripe_connect_activated.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
  credit_card_tax: {
    fieldPath: 'credit_card_tax',
    fieldReadPath: 'credit_card_tax',
    name: 'credit_card_tax',
    label: 'core.stripe.credit_card_tax.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'percent',
  },
  credit_card_minimum: {
    fieldPath: 'credit_card_minimum',
    fieldReadPath: 'credit_card_minimum',
    name: 'credit_card_minimum',
    label: 'core.stripe.credit_card_minimum.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  credit_card_maximum: {
    fieldPath: 'credit_card_maximum',
    fieldReadPath: 'credit_card_maximum',
    name: 'credit_card_maximum',
    label: 'core.stripe.credit_card_maximum.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  credit_card_fix: {
    fieldPath: 'credit_card_fix',
    fieldReadPath: 'credit_card_fix',
    name: 'credit_card_fix',
    label: 'core.stripe.credit_card_fix.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  bancontact_tax: {
    fieldPath: 'bancontact_tax',
    fieldReadPath: 'bancontact_tax',
    name: 'bancontact_tax',
    label: 'core.stripe.bancontact_tax.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'percent',
  },
  bancontact_minimum: {
    fieldPath: 'bancontact_minimum',
    fieldReadPath: 'bancontact_minimum',
    name: 'bancontact_minimum',
    label: 'core.stripe.bancontact_minimum.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  bancontact_maximum: {
    fieldPath: 'bancontact_maximum',
    fieldReadPath: 'bancontact_maximum',
    name: 'bancontact_maximum',
    label: 'core.stripe.bancontact_maximum.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  bancontact_fix: {
    fieldPath: 'bancontact_fix',
    fieldReadPath: 'bancontact_fix',
    name: 'bancontact_fix',
    label: 'core.stripe.bancontact_fix.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: ['required', 'numeric'],
    warningRules: [],
    inputType: 'input-group',
    fieldAttributes: {
      autocomplete: 'off',
      type: 'number',
      step: '0.01',
    },
    appendIcon: 'euro-sign',
  },
  stripe_client_id: {
    fieldPath: 'stripe_client_id',
    fieldReadPath: 'stripe_client_id',
    name: 'stripe_client_id',
    label: 'core.stripe.stripe_client_id.label',
    showLabel: true,
    options: [],
    veeValidation: true,
    rules: [],
    warningRules: [],
  },
};
